export const lawyers = [
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/ade.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/alfred.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/ali.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/andrian.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/bagus.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/dwi.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/frandy.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/hanna.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/kiki.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/lolita.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/marini.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/muslih.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/putu.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/riza.jpg",
  "https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/lawyer/taufan.jpg",
];